module.exports = __webpack_public_path__ + "img/logo-whatsapp.e917b6bf.png";